import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Page } from "@shared/page.constants";
import { JsonResponse } from "src/types/response";

@Injectable({
  providedIn: "root",
})
export class PagesProvider {

  constructor(
    private httpClient: HttpClient
  ) {}

  paginate(params: any): Observable<any> {
    return this.httpClient.get("/api/pages", {
      params,
    });
  }

  list(): Observable<any> {
    return this.httpClient.get("/api/pages/list");
  }

  editOpen(id: string, override?: boolean): Observable<any> {
    return this.httpClient.post(`/api/pages/${id}/open`, {
      override,
    });
  }

  editClose(id: string, publish?: boolean): Observable<any> {
    return this.httpClient.post(`/api/pages/${id}/close`, {
      publish,
    });
  }

  save(data: Page): Observable<JsonResponse<Page>> {
    return this.httpClient.post<JsonResponse<Page>>("/api/pages", data);
  }

  recover(id: string): Observable<any> {
    return this.httpClient.post(`/api/pages/${id}/recover`, null);
  }

  delete(id: string): Observable<any> {
    return this.httpClient.delete(`/api/pages/${id}`);
  }

  deletePermanently(id: string): Observable<any> {
    return this.httpClient.delete(`/api/pages/${id}/delete`);
  }

  publish(id: string, publish: boolean): Observable<any> {
    return this.httpClient.post(`/api/pages/${id}/publish`, {
      publish,
    });
  }

  history(id: string): Observable<any> {
    return this.httpClient.get(`/api/pages/${id}/history`);
  }

  getBySlug(slug: string): Observable<any> {
    return this.httpClient.get(`/api/page/${slug}`);
  }

  getAssets(): Observable<any> {
    return this.httpClient.get(`/api/pages/assets`);
  }

  deleteAsset(id: string): Observable<any> {
    return this.httpClient.delete(`/api/pages/assets/${id}`);
  }

  getAssetForDownload(asset:any): Observable<any> {
    return this.httpClient.get(`/api/uploads/assets/${asset.name}`);
  }
}
